import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
  },
  title: {
    marginLeft: '1rem',
    fontSize: 28,
    color: theme.colors.light.freshPowder,
  },
}));
